<template>
  <div class="numCount" :class='{numCount_large:large,numCount:!large}'>
    <i class="minus" @click.stop="$emit('minus')" v-if='!disabel'></i><span class="f28 bold t_center grey">{{num}}</span><i class="plus" @click.stop="$emit('plus')"  v-if='!disabel'></i>
  </div>
</template>

<script>
  export default {
    name: 'numCount',
    props: {
      num: {
        type: Number,
        default: 0
      },
      disabel:{
        type : Boolean,
        default : false
      },
      large:{
        type : Boolean,
        default : true
      }
    },
    data () {
      return {}
    },
    watch: {},
    computed: {},
    created () {
    },
    mounted () {
    },
    methods: {}

  }
</script>

<style lang="scss" scoped>
  .grey{
    color:#9B9B9B;
    position: relative;
    top:3px;
  }
  .numCount{
    height: 46px;
    line-height: 46px;
    i,span{
      display: inline-block;
      width: 46px;height: 46px;
      vertical-align: middle;
    }
    span{
      width: 40px;
    }
    i{
      background: url("/images/home/minus_icon.png") no-repeat center;
      background-size: 30px;
    }
    .plus{
      background-image:  url("/images/home/plus_icon.png") ;
    }
  }
  
  .numCount_large{
    height: 46px;
    line-height: 46px;
    i,span{
      display: inline-block;
      width: 46px;height: 46px;
      vertical-align: middle;
    }
    span{
      width: 60px;
    }
    i{
      background: url("/images/home/minus_icon.png") no-repeat center;
      background-size: 46px;
    }
    .plus{
      background-image:  url("/images/home/plus_icon.png") ;
    }
  }

</style>
